/**
 * Condition settings keys. This should be in sync with WorkbookSettingsConstants.java
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const CONDITION_SETTINGS = {
  MANDATORY: 'mandatory',
  ANIMATION_ALLOW: 'condition.animation.allow',
  ANIMATION_NUMBER_OF_FRAMES: 'condition.animation.numberOfFrames',
  TABLE_CONDITION_CONTEXT_SENSITIVE: 'contextSensitive',
  TABLE_CONDITION_EXCLUDE_VALUES: 'excludeValues',
  TABLE_CONDITION_ALLOW_EXCLUDE_VALUES: 'allowExcludeValues',
  TABLE_CONDITION_MODE: 'mode',
  TABLE_CONDITION_LIMIT: 'limit',
  LIKE_CONDITION_FILTER_TYPE: 'filterType',
  LIKE_CONDITION_CASE_SENSITIVITY: 'caseSensitivity',
  LIKE_CONDITION_COMBINATION_TYPE: 'combinationType',
  VALUE_INTERVAL_CONDITION_LOWER_BOUNDARY_TYPE: 'lowerBoundaryIntervalLimitType',
  VALUE_INTERVAL_CONDITION_UPPER_BOUNDARY_TYPE: 'upperBoundaryIntervalLimitType',
  DATE_CONDITION_MODE: 'mode',
  DATE_CONDITION_INTERVAL: 'isInterval',
  DATE_CONDITION_INTERVAL_UNIT: 'condition.date.intervalUnit',
  DATE_CONDITION_INTERVAL_LENGTH: 'condition.date.intervalLength',
  DATE_CONDITION_INTERVAL_OVERLAP_LENGTH: 'condition.date.overlapLength',
  DATE_CONDITION_MODE_DATA_INPUT_ENABLED: 'condition.date.dataInputModeEnabled',
  DATE_CONDITION_MODE_STEPS_ENABLED: 'condition.date.stepsModeEnabled',
  DATE_CONDITION_ACTIVE_FILTER_MODE: 'condition.date.filterMode',
  DATE_CONDITION_FORMAT: 'condition.date.format',
  DATE_INTERVAL_CONDITION_MODE: 'mode',
  SPATIAL_CONDITION_RELATION: 'condition.spatial.relation'
};
